export default {
  setWindowSize: (state, payload) => {
    state.width = payload.width
    state.height = payload.height
    state.scrollheight = payload.scrollheight
    state.mobile = payload.width < state.mobilesize
    state.small = payload.width < state.smallsize
  },
  setWindowProgress: (state, payload) => {
    if (payload) state.progress = payload
  },
  setDevice: (state, payload) => {
    state.isdevice = payload
  }
}



// WEBPACK FOOTER //
// ./assets/js/store/modules/viewport/mutations.js